document.addEventListener('DOMContentLoaded', function () {
  const plusBtn = document.getElementById('increase-qty');
  const minBtn = document.getElementById('decrease-qty');
  const qtyInput = document.getElementById('simple-qty');
  const originalPriceHtml = document.querySelector('[data-solo-price]');
  const crossselling = document.querySelectorAll('.crossselling-product');
  const extraInformatie = document.getElementById('extra-informatie');
  const extraInformatieHidden = document.getElementById('extra-informatie-hidden');
  let totalPrice = 0;
  let totalPriceWithAdd = 0;
  let additionalPriceCross = 0;

  plusBtn.addEventListener('click', function () {
    let originalPrice = document.querySelector('[data-solo-price]').getAttribute('data-solo-price');
    let currentValue = parseInt(qtyInput.value);
    let additionalPrice = 0;

    crossselling.forEach(function (product) {
      const checkbox = product.querySelector('input[type="checkbox"]');
      if (checkbox.checked) {
        const price = parseFloat(product.querySelector('[data-product-price]').getAttribute('data-product-price'));
        additionalPrice += price;
      }
    });

    totalPrice = originalPrice * currentValue;
    totalPriceWithAdd = totalPrice + additionalPrice;
    originalPriceHtml.innerHTML = formatMoney(totalPriceWithAdd);
  });

  minBtn.addEventListener('click', function () {
    let originalPrice = document.querySelector('[data-solo-price]').getAttribute('data-solo-price');
    let currentValue = parseInt(qtyInput.value);
    let additionalPrice = 0;

    crossselling.forEach(function (product) {
      const checkbox = product.querySelector('input[type="checkbox"]');
      if (checkbox.checked) {
        const price = parseFloat(product.querySelector('[data-product-price]').getAttribute('data-product-price'));
        additionalPrice += price;
      }
    });

    totalPrice = originalPrice * currentValue;
    totalPriceWithAdd = totalPrice + additionalPrice;
    originalPriceHtml.innerHTML = formatMoney(totalPriceWithAdd);
  });

  crossselling.forEach(function (product) {
    const checkbox = product.querySelector('input[type="checkbox"]');
    if (checkbox) {
      checkbox.addEventListener('change', function () {
        let originalPrice = document.querySelector('[data-solo-price]').getAttribute('data-solo-price');
        let currentValue = parseInt(qtyInput.value);
        const price = parseFloat(product.querySelector('[data-product-price]').getAttribute('data-product-price'));
        if (checkbox.checked) {
          additionalPriceCross += price;
        } else {
          additionalPriceCross -= price;
        }

        totalPrice = originalPrice * currentValue;
        totalPriceWithAdd = totalPrice + additionalPriceCross;
        originalPriceHtml.innerHTML = formatMoney(totalPriceWithAdd);
      });
    }
  });

  extraInformatie.addEventListener('input', (event) => {
    // Get the current value of the input field
    const currentValue = event.target.value;
    console.log('Input value changed to:', currentValue);
    extraInformatieHidden.value = currentValue;
  });
});

function formatMoney(cents) {
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents);
  }
  // Fallback formatting if Shopify.formatMoney is not available
  return (cents / 100).toFixed(2).replace('.', ',') + ' €';
}
